import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetAuth } from '../../Auth/AuthProvider';
import { r2_updateData } from '../../Helpers/r2_requests';
import {
  Box,
  Grid,
  Typography,
  TextField,
  Divider,
  Button,
  Switch,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  Modal,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import Upload from '../Upload/Upload';
import ViewUploads from '../Upload/ViewUploads';

import { filterMethod } from '../../Helpers/helpers';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';
import { padding } from '@mui/system';

import { modalStyle1024 } from '../shared/commonStyle';
import PermissionsAutocomplete from '../CommonComponents/PermissionsAutocomplete';

const UserEdit = (props) => {
  // const navigateBack = useNavigate();
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [forceUpdate, setForceUpdate] = useState(1);
  const navigateBack = useNavigate();

  const thisRowData = props.thisRowData;
  const cancelEdit = props.cancelEdit;

  const [active, setActive] = useState(
    thisRowData.active === undefined ? true : thisRowData.active
  );
  const [name, setName] = useState(thisRowData.name || '');
  const [surname, setSurname] = useState(thisRowData.surname || '');
  const [userName, setUserName] = useState(thisRowData.username);
  const [password, setPassword] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  // const [password, setPassword] = useState(thisRowData.password);
  const [contactNumber, setContactNumber] = useState(
    thisRowData.contact_number
  );
  const [email, setEmail] = useState(thisRowData.email);

  const [type, setType] = useState(thisRowData.type);

  const superAdmin =
    thisRowData.permissions.super_admin === undefined
      ? false
      : thisRowData.permissions.super_admin;

  const [manager, setManager] = useState(
    thisRowData.permissions.manager === undefined
      ? false
      : thisRowData.permissions.manager
  );
  const [supervisor, setSupervisor] = useState(
    thisRowData.permissions.supervisor === undefined
      ? false
      : thisRowData.permissions.supervisor
  );
  const [controller, setController] = useState(
    thisRowData.permissions.controller === undefined
      ? false
      : thisRowData.permissions.controller
  );
  const [finance, setFinance] = useState(
    thisRowData.permissions.finance === undefined
      ? false
      : thisRowData.permissions.finance
  );
  const [technician, setTechnician] = useState(
    thisRowData.permissions.technician === undefined
      ? false
      : thisRowData.permissions.technician
  );

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handlePermissions = (data) => {
    setType(data);
  };

  const handleChange = (event) => {
    const eventId = event.target.id;

    switch (eventId) {
      case 'isActive':
        setActive(event.target.checked);
        break;
      case 'name':
        setName(event.target.value);
        break;
      case 'surname':
        setSurname(event.target.value);
        break;
      case 'userName':
        event.target.value.trim() === ''
          ? setUserName(undefined)
          : setUserName(event.target.value.trim());
        break;
      case 'password':
        event.target.value.trim() === ''
          ? setPassword(null)
          : setPassword(event.target.value.trim());
        break;
      case 'contactNumber':
        setContactNumber(event.target.value);
        break;
      case 'email':
        setEmail(event.target.value);
        break;
      case 'manager':
        setManager(event.target.checked);
        break;
      case 'supervisor':
        setSupervisor(event.target.checked);
        break;
      case 'finance':
        setFinance(event.target.checked);
        break;
      case 'controller':
        setController(event.target.checked);
        break;
      case 'technician':
        setTechnician(event.target.checked);
        break;

      default:
        break;
    }
  };

  const handlePassword = (blob) => {
    const oldBlob = { ...blob };
    const newBlob = { ...blob, password: password };
    const saveBlob = password === null ? { user: oldBlob } : { user: newBlob };
    return saveBlob;
  };

  const dataBlob = {
    active: active,
    contact_number: contactNumber,
    email: email,
    name: name,
    permissions: {
      username: userName,
      // super_admin: superAdmin,
      // manager: manager,
      // supervisor: supervisor,
      // finance: finance,
      // controller: controller,
      // technician: technician,
    },
    surname: surname,
    type: type,
    username: userName,
  };

  const handleSave = () => {
    if (type === undefined) {
      enqNotification('Permission Type must be selected!', 'error');
      return;
    } else {
      const setBlob = handlePassword(dataBlob);
      const updateType = 'user';
      // const path = '/admin/users';
      const uri =
        thisRowData.id === undefined
          ? `/r2_users`
          : `/r2_users/${thisRowData.id}`;

      r2_updateData({
        uri: uri,
        dataBlob: setBlob,
        // cancelEdit: cancelEdit,
        cancelEdit: () => cancelEdit(),
        setForceUpdate,
        navigateBack,
        path: '/admin/users',
        logout: logout,
        enqNotification: enqNotification,
        updateMessage: 'User updated',
        type: updateType,
        state: 'admin',
      });
    }
  };

  const [openUploads, setOpenUploads] = useState();
  const handleOpenUploads = () => {
    setOpenUploads(true);
  };
  const handleCloseUploads = () => {
    setOpenUploads(false);
    setForceUpdate(forceUpdate + 1);
  };

  const [openViewUploads, setOpenViewUploads] = useState();
  const handleOpeViewUploads = () => {
    setOpenViewUploads(true);
  };
  const handleCloseViewUploads = () => {
    setOpenViewUploads(false);
    setForceUpdate(forceUpdate + 1);
  };

  return (
    <Box sx={boxStyle}>
      <Grid container rowGap={2}>
        <Grid
          xs={12}
          md={8}
          sx={{
            border: '1px #c4c4c4 solid',
            // borderBottom: 'none',
            borderRadius: '15px 15px 0 0 ',
            padding: ' 10px 0 0 0 ',
            textTransform: 'capitalize',
          }}
          item
        >
          {/* <Typography variant='h4'>{`${name} ${surname}`}</Typography> */}
          <Typography variant='h4'>User Details</Typography>
        </Grid>
        <Grid
          xs={0}
          md={4}
          item
          sx={{ borderBottom: '1px #c4c4c4 solid' }}
        ></Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>Active:</Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>
            <Switch
              id='isActive'
              checked={active}
              onChange={(event) => handleChange(event)}
            />
            {active === true ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        <Grid xs={12} md={6} item>
          <PermissionsAutocomplete
            // setByType={(data) => setType(data)}
            setByType={(data) => handlePermissions(data)}
            permisionsType={thisRowData.type}
            nameLabel='Permission Type'
            id='permissionType'
          />
        </Grid>

        <Grid xs={12} md={6} item>
          <TextField
            sx={{ width: '80%' }}
            id='name'
            label='Name & Surname'
            variant='outlined'
            value={name}
            onChange={(event) => handleChange(event)}
          />
        </Grid>
        <Grid xs={12} md={6} item>
          <TextField
            sx={{ width: '80%' }}
            id='surname'
            label='Department'
            variant='outlined'
            value={surname}
            onChange={(event) => handleChange(event)}
          />
        </Grid>

        <Grid xs={12} md={6}>
          <TextField
            sx={{ width: '80%' }}
            id='userName'
            label='User Name'
            variant='outlined'
            value={userName}
            onChange={(event) => handleChange(event)}
          />
        </Grid>
        <Grid xs={12} md={6}>
          <FormControl sx={{ width: '80%' }}>
            <InputLabel htmlFor='outlined-adornment-password'>
              Password
            </InputLabel>
            <OutlinedInput
              sx={{ width: '100%' }}
              id='password'
              label='Password'
              variant='outlined'
              type={showPassword ? 'text' : 'password'}
              value={password}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge='end'
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(event) => handleChange(event)}
              autoComplete='new-password'
            />
          </FormControl>
        </Grid>
        <Grid xs={12} md={6}>
          <TextField
            sx={{ width: '80%' }}
            id='contactNumber'
            label='Contact Number'
            variant='outlined'
            value={contactNumber}
            onChange={(event) => handleChange(event)}
          />
        </Grid>
        <Grid xs={12} md={6}>
          <TextField
            sx={{ width: '80%' }}
            id='email'
            label='Email'
            variant='outlined'
            value={email}
            onChange={(event) => handleChange(event)}
          />
        </Grid>
      </Grid>
      {/* <Divider sx={{ marginTop: '15px' }} /> */}

      {/* <Grid container rowGap={2}>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>Manager:</Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>
            <Switch
              id='manager'
              checked={manager}
              onChange={(event) => handleChange(event)}
            />
            {manager === true ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>Supervisor:</Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>
            <Switch
              id='supervisor'
              checked={supervisor}
              onChange={(event) => handleChange(event)}
            />
            {supervisor === true ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>Controller:</Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>
            <Switch
              id='controller'
              checked={controller}
              onChange={(event) => handleChange(event)}
            />
            {controller === true ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>Finance:</Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>
            <Switch
              id='finance'
              checked={finance}
              onChange={(event) => handleChange(event)}
            />
            {finance === true ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>Technician:</Typography>
        </Grid>
        <Grid xs={6} md={3} item>
          <Typography variant='h5'>
            <Switch
              id='technician'
              checked={technician}
              onChange={(event) => handleChange(event)}
            />
            {technician === true ? 'Yes' : 'No'}
          </Typography>
        </Grid>
      </Grid> */}

      <Divider sx={{ marginTop: '15px' }} />
      <Box align='right'>
        <Button
          variant='contained'
          color='warning'
          onClick={handleOpenUploads}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Upload Documents
        </Button>
        <Button
          variant='contained'
          color='success'
          onClick={handleOpeViewUploads}
          sx={{ margin: '15px 0 0 10px' }}
        >
          View Documents
        </Button>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Save
        </Button>
        <Button
          variant='contained'
          color='secondary'
          onClick={cancelEdit}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Cancel
        </Button>
      </Box>
      <Modal
        open={openUploads}
        onClose={handleCloseUploads}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle1024}>
          <Upload relationId={thisRowData.id} relationType='userAdmin' />
        </Box>
      </Modal>
      <Modal
        open={openViewUploads}
        onClose={handleCloseViewUploads}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle1024}>
          <ViewUploads relationId={thisRowData.id} relationType='userAdmin' />
        </Box>
      </Modal>
    </Box>
  );
};

export default UserEdit;
const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
};
